import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import UniversalToast from '../../components/UniversalToast';
import './Profile.css';
import './Settings.css';
import { Lock, FileText, ShieldCheck, Users as UsersIcon, ChevronRight } from 'lucide-react';

const Settings: React.FC = () => {
    const navigate = useNavigate();

    const [user, setUser] = useState(() => {
        try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
    });

    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState<'loading' | 'success' | 'error' | 'copy'>('success');
    const [toastMessage, setToastMessage] = useState('');
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [resetCountdown, setResetCountdown] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            try {
                const updated = JSON.parse(localStorage.getItem('user') || '{}');
                setUser(updated);
            } catch { }
        }, 1000);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        if (resetCountdown <= 0) return;
        const t = setTimeout(() => setResetCountdown(c => c - 1), 1000);
        return () => clearTimeout(t);
    }, [resetCountdown]);

    const openToast = (type: 'loading' | 'success' | 'error' | 'copy', message: string, autoHide = true) => {
        setToastType(type);
        setToastMessage(message);
        setShowToast(true);
        if (autoHide) setTimeout(() => setShowToast(false), 1500);
    };

    const handleResetPassword = async () => {
        if (!user?.email) return;
        try {
            await api.post('/auth/forgot-password', { email: user.email });
            openToast('success', 'Password reset email sent');
            setResetCountdown(60);
        } catch {
            openToast('success', 'Password reset email sent');
            setResetCountdown(60);
        }
    };


    const confirmLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.dispatchEvent(new CustomEvent('userLogin'));
        navigate('/login');
    };

    return (
        <div className="profile-container settings-container">

            {/* Account info removed as requested */}

            {/* Security section */}
            <div className="profile-actions settings-security">
                <button
                    className="auth-button settings-reset-button"
                    onClick={handleResetPassword}
                    disabled={resetCountdown > 0}
                >
                    <span className="settings-item-icon"><Lock size={18} /></span>
                    <span>
                        Reset Password {resetCountdown > 0 ? `(${resetCountdown}s)` : ''}
                    </span>
                </button>

                {/* Legal */}
                <div className="settings-legal">
                    <button className="auth-button secondary" onClick={() => navigate('/legal/terms')}>
                        <span className="settings-item-left"><span className="settings-item-icon"><FileText size={18} /></span><span>Terms and Conditions</span></span>
                        <span className="settings-item-arrow"><ChevronRight size={18} /></span>
                    </button>
                    <button className="auth-button secondary" onClick={() => navigate('/legal/privacy')}>
                        <span className="settings-item-left"><span className="settings-item-icon"><ShieldCheck size={18} /></span><span>Privacy Policy</span></span>
                        <span className="settings-item-arrow"><ChevronRight size={18} /></span>
                    </button>
                    <button className="auth-button secondary" onClick={() => navigate('/legal/community-guidelines')}>
                        <span className="settings-item-left"><span className="settings-item-icon"><UsersIcon size={18} /></span><span>Community Guidelines</span></span>
                        <span className="settings-item-arrow"><ChevronRight size={18} /></span>
                    </button>
                </div>
            </div>

            {/* Logout modal */}
            {showLogoutModal && (
                <div className="post-delete-modal-overlay" onClick={() => setShowLogoutModal(false)}>
                    <div className="post-delete-modal-content settings-logout-modal" onClick={(e) => e.stopPropagation()}>
                        <h3 className="settings-logout-title">Logout</h3>
                        <p className="settings-logout-message">Are you sure you want to logout?</p>
                        <div className="postcard-delete-modal-actions settings-logout-actions">
                            <button className="auth-button" onClick={() => setShowLogoutModal(false)}>Cancel</button>
                            <button className="auth-button settings-logout-confirm" onClick={confirmLogout}>Logout</button>
                        </div>
                    </div>
                </div>
            )}

            <UniversalToast type={toastType} message={toastMessage} show={showToast} />
        </div>
    );
};

export default Settings;


